import configureStore from './configure-store';

const { store } = configureStore();

// TODO: Remove after debugging!
window.__store__ = store;

export default store;
